import React from 'react'
import '../App.css'
import logo from '../components/logo.png'
const Navbar = () => {
  return (
    <div className='navbar'>
        <img src={logo}/>
    </div>
  )
}

export default Navbar
